export { ZoomImage } from './zoom-image';
